import React from 'react'

const withEventHandlers = WrappedComponent => {
  return props => {
    const {
      modalId,
      setModal // via redux actions
    } = props

    const handleClickProductInfo = e => {
      e.preventDefault()
      setModal({ id: modalId, open: true })
    }

    return <WrappedComponent onClick={handleClickProductInfo} {...props} />
  }
}

export default withEventHandlers
